import {addLocale, locale} from "primereact/api";

const setLocale = () => {
    addLocale('it',{
        "accept": "Sì",
        "reject": "No",
        "choose": "Scegli",
        "upload": "Carica",
        "cancel": "Annulla",
        "dayNames": ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
        "dayNamesShort": ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
        "dayNamesMin": ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
        "monthNames": ["Gennaio", "Febbraio", "Marzo", "April", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
        "monthNamesShort": ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
        "today": "Oggi",
        "clear": "Pulisci",
        "weekHeader": "Sett.",
        "firstDayOfWeek": 1,
        "dateFormat": "dd/mm/yy",
        "weak": "Debole",
        "medium": "Medio",
        "strong": "Forte",
        "passwordPrompt": "Inserisci la password"
    });

    locale("it");
};

export default setLocale;